export const CONSENT_KEY = "apf-consent-v1";
export const CONSENT_DAYS = 180;
export const DENIED = Object.freeze({ necessary: true, analytics: false, marketing: false });
export const ALL = Object.freeze({ necessary: true, analytics: true, marketing: true });

export const readRecord = () => {
    try {
        const record = JSON.parse(localStorage.getItem(CONSENT_KEY));
        return record?.version === 1 && typeof record.configKey === "string" && Number.isFinite(record.expiresAt) && record.expiresAt > Date.now() &&
            typeof record.categories?.analytics === "boolean" && typeof record.categories?.marketing === "boolean"
            ? record : null;
    } catch { return null; }
};

export const persistConsent = (categories, configKey) => {
    const record = {
        version: 1, savedAt: new Date().toISOString(), expiresAt: Date.now() + CONSENT_DAYS * 86400000,
        configKey, categories: { necessary: true, analytics: !!categories.analytics, marketing: !!categories.marketing },
    };
    try { localStorage.setItem(CONSENT_KEY, JSON.stringify(record)); } catch { /* vale per questa visita */ }
    return record;
};

export const cleanVendorStorage = ({ analytics, marketing }) => {
    const matches = (name) => (analytics && /^(_ga(?:_|$)|_gid$|_gat(?:_|$)|ph_.*_posthog$)/.test(name)) ||
        (marketing && /^(_gcl_|_fbp$|_fbc$|_ttp$|_tt_enable_cookie$|ttcsid(?:_|$)|ttclid$)/.test(name));
    const hosts = window.location.hostname.split(".");
    const domains = ["", ...hosts.slice(0, -1).map((_, i) => `; Domain=${hosts.slice(i).join(".")}`)];
    const parts = window.location.pathname.split("/").filter(Boolean);
    const paths = ["/", ...parts.map((_, i) => `/${parts.slice(0, i + 1).join("/")}`)];
    document.cookie.split(";").map((cookie) => cookie.split("=")[0].trim()).filter(matches).forEach((name) => {
        domains.forEach((domain) => paths.forEach((path) => {
            document.cookie = `${name}=; Max-Age=0; Path=${path}${domain}; SameSite=Lax`;
        }));
    });
    try {
        Object.keys(localStorage).filter(matches).forEach((key) => localStorage.removeItem(key));
        if (analytics) localStorage.removeItem("apf-variant");
    } catch { /* lo storage può essere disabilitato */ }
};